/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const IDS = {
    content: "content",
    toggle: "toggle",
};
export const CSS = {
    chevronIcon: "chevron-icon",
    content: "content",
    iconStart: "icon--start",
    iconEnd: "icon--end",
    invalid: "invalid",
    sectionHeader: "section-header",
    sectionHeaderText: "section-header__text",
    statusIcon: "status-icon",
    switch: "switch",
    toggle: "toggle",
    toggleSwitch: "toggle--switch",
    toggleContainer: "toggle-container",
    toggleSwitchContent: "toggle--switch__content",
    toggleSwitchText: "toggle--switch__text",
    valid: "valid",
};
export const ICONS = {
    menuOpen: "chevron-up",
    menuClosed: "chevron-down",
    valid: "check-circle",
    invalid: "exclamation-mark-triangle",
};
//# sourceMappingURL=resources.js.map
